var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({attrs:{"is-loading":_vm.isLoading}},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.details)?_c('p',{staticClass:"text-content"},[_c('vue-markdown',{attrs:{"source":_vm.details}})],1):_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17105a2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelfPost/SelfPost.vue
// module id = KnAa
// module chunks = 1